import React, { useEffect } from "react";
import './style.css'
export default function Gallery(props) {
  const { gallery } = props; 

    useEffect(() => {},[gallery])
    
    return (
      <section className="img_container">
        {gallery?
          gallery.map((src, ind) => { 
            return <img key={ind} className="myImg" src={src} alt='gallery-image-missing' />
          }) 
          : null
        }
      </section>
    )
  }
  
  
